'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Navbar from '../../../../components/atlas/Navbar';
import Footer from '../../../../components/atlas/Footer';
import styles from '../../auth.module.css';

type ForgotFormValues = {
  email: string;
};

export default function ForgotPasswordPage() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'sent'>('idle');
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit } = useForm<ForgotFormValues>();

  const onSubmit = async (values: ForgotFormValues) => {
    setError(null);
    setStatus('loading');
    try {
      const res = await fetch('/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });

      if (res.ok) {
        setStatus('sent');
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.error ?? 'Errore durante il reset');
        setStatus('idle');
      }
    } catch {
      setError('Errore di rete, riprova');
      setStatus('idle');
    }
  };

  return (
    <>
      <Navbar showActions={false} />

      <main className={styles.authPage}>
        <div className={styles.authCard}>
          <h1>Forgot Password?</h1>
          <p className={styles.authSubtitle}>Reset password in two quick steps</p>

          {status === 'sent' ? (
            <div className={styles.authSuccess}>
              <p>
                Se l&apos;email è registrata riceverai a breve il link di reset.
              </p>
              {/* Bottone "Torna al Login" disabilitato: non esiste una pagina di login attiva.
                  Per riattivarlo: togliere i commenti dal blocco sotto.
              <button
                className='btn btn-primary btn-full'
                style={{ marginTop: '16px' }}
                onClick={() => router.push('/account/login')}
              >
                Torna al Login
              </button>
              */}
            </div>
          ) : (
            <form className={styles.authForm} onSubmit={handleSubmit(onSubmit)}>
              <div className={styles.formGroup}>
                <label htmlFor='email'>Email</label>
                <input
                  id='email'
                  type='email'
                  placeholder='name@example.com'
                  required
                  {...register('email')}
                />
              </div>

              {error && <p className={styles.authError}>{error}</p>}

              <div className={styles.forgotActions}>
                <button
                  type='submit'
                  className='btn btn-primary btn-full'
                  disabled={status === 'loading'}
                >
                  {status === 'loading' ? 'Invio…' : 'Reset Password'}
                </button>
                {/* Bottone "Back to Login" disabilitato: non esiste una pagina di login attiva.
                    Per riattivarlo: togliere i commenti dal blocco sotto.
                <button
                  type='button'
                  className='btn btn-secondary btn-full'
                  onClick={() => router.push('/account/login')}
                >
                  Back to Login
                </button>
                */}
              </div>
            </form>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}
